// One definition of the posting-path field, shared by the two places it is
// edited: the new-location page and the "Posting file" card. They drifted
// apart once already — different placeholder, different description, and one
// marked required while the other was optional, which left a location created
// without a path sitting on a detail page whose stream card was invalid the
// moment it loaded.
//
// Optional in both. `streams.file_path` is NOT NULL but an empty string
// satisfies it, the create endpoint does not validate it, and PATCH rejects
// only an explicit null — so "not configured yet" is a real, storable state,
// and the UI has to let you both reach it and leave it.

export const POSTING_PATH_LABEL = "Posting file path";

export const POSTING_PATH_PLACEHOLDER = String.raw`C:\Micros\…\KdsPost.txt`;

/** Deliberately context-free: it reads the same before and after the location
 *  exists, which is what keeps the two fields identical. */
export const POSTING_PATH_DESCRIPTION =
    "The posting file the posting service reads on the location's POS terminal. It has nothing to read until this is set.";
